<mat-tab-group>
    <mat-tab label="{{'CERTIFICAR.FORALL.TABLA.TITULOS.DEFAULT' | translate}}">
      <practicas (idiomasGuardados)="enviaIdiomasGuardados($event)" (seccionesGuardadas)="enviaSeccionesGuardadas($event)" [actualizaCuestionarioTrad]="actualizaJsonTrad.asObservable()" [statusPaso]="statusPaso.asObservable()"></practicas>
    </mat-tab>
    <mat-tab label="{{'CERTIFICAR.FORALL.TABLA.TITULOS.TRADUCCION' | translate}}" *ngIf="traduccionesTab">
      <traducciones (actualizaCuestionario)="actualizaCuestionarioTrad($event)" (traduccionesCompletas)="traduccionesCompletas = $event" [idiomasGuardados]="idiomasGuardados.asObservable()" [seccionesGuardadas]="seccionesGuardadas.asObservable()" [statusPaso]="statusPaso.asObservable()"></traducciones>
    </mat-tab>
    <mat-tab label="{{'CERTIFICAR.FORALL.TABLA.TITULOS.PREVIEW' | translate}}">
      <preview [idiomasGuardados]="idiomasGuardados.asObservable()" [seccionesGuardadas]="seccionesGuardadas.asObservable()"></preview>
    </mat-tab>
</mat-tab-group>

<!-----------boton finalizar paso---------->
<ng-container *ngIf="changeInfoFin">
  <div fxLayout="row" fxLayoutAlign="end end" class="mb-20 finishBt">
    <button *ngIf="!pasoCompleto" (click)="completarPaso()" mat-fab aria-label="boton completar paso" matTooltip="{{'CERTIFICAR.FORALL.STATUS.PEND' | translate}}" matTooltipPosition="left" class="undone mr-20">
      <mat-icon>done</mat-icon>
    </button>
    <button *ngIf="pasoCompleto" (click)="completarPaso()" mat-raised-button class="done mr-20">
      {{'CERTIFICAR.FORALL.STATUS.DONE' | translate}}
      <mat-icon class="ml-20">done</mat-icon>
    </button>
    <!-- desbloquearPaso -->
    <button *ngIf="pasoCompleto && (validationUser || desbloqueoEstatus) && !validationSurvey" (click)="desbloquear4all()" mat-fab aria-label="" matTooltip="{{'CERTIFICAR.FORALL.STATUS.LOCK' | translate}}" matTooltipPosition="left" class="undone mr-20">
      <mat-icon>lock_open</mat-icon>
    </button>

    <button *ngIf="!pasoCompleto && (validationUser || desbloqueoEstatus) && !validationSurvey" (click)="desbloquear4all()" mat-raised-button class="reopen mr-20">
      {{'CERTIFICAR.FORALL.STATUS.UNLOCK' | translate}}
    </button>
  </div>
</ng-container>
